import { BreadCrumbItemViewModel } from "./viewModel"

export const CREATOR_MYPAGE_ITEM: BreadCrumbItemViewModel = {
  label: "マイページ",
  linkUrl: "/creator/mypage",
}
